import React, { useState } from 'react';
import '../css/PageLayout.css';

function PageLayout({
    title,
    description,
    children,
    onSubmit,
    isFileUpload = false,
    validateFile = () => true,
    error,
    statusMessage,
    multiple = false,
    acceptTypes = ".xlsx,.xls",
    submitButtonText = 'Import',  // 버튼 텍스트 prop 추가
    fileUploadButtonText = '파일 선택'  // 파일 선택 버튼 텍스트 prop 추가
}) {
    const [files, setFiles] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const filesPerPage = 10;
    const indexOfLastFile = currentPage * filesPerPage;
    const indexOfFirstFile = indexOfLastFile - filesPerPage;
    const currentFiles = files.slice(indexOfFirstFile, indexOfLastFile);
    const totalPages = Math.ceil(files.length / filesPerPage);
    const handleFileChange = (e) => {
        const selectedFiles = Array.from(e.target.files);

        if (selectedFiles.every(validateFile)) {
            if (multiple) {
                // 중복 파일 체크
                const newFiles = selectedFiles.filter(newFile =>
                    !files.some(existingFile => existingFile.name === newFile.name)
                );
                setFiles(prev => {
                    const updatedFiles = [...prev, ...newFiles];
                    console.log('업데이트된 파일 목록:', updatedFiles);
                    return updatedFiles;
                });
            } else {
                setFiles(selectedFiles);
            }
        } else {
            alert('유효하지 않은 파일 형식입니다.');
        }

        console.log('새로 선택된 파일들:', selectedFiles);
        console.log('multiple 옵션:', multiple);
        e.target.value = '';
    };


    const handleRemoveFile = (indexToRemove) => {
        setFiles(files.filter((_, index) => index !== indexToRemove));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (isFileUpload && files.length === 0) return;

        setIsLoading(true);
        try {
            const formData = new FormData();
            if (isFileUpload) {
                files.forEach(file => formData.append('files', file));
            }
            await onSubmit(formData);  // formData를 전달
        } finally {
            setIsLoading(false);
        }
    };

    const clearAllFiles = () => {
        setFiles([]);
    };
    const handlePageChange = (pageNumber) => {
        setCurrentPage(pageNumber);
    };
    return (
        <div className="page-layout">
            <div className="content-wrapper">
                <h2>{title}</h2>
                {description}

                <form onSubmit={handleSubmit}>
                    {isFileUpload && (
                        <div className="file-upload-container">
                            <input
                                type="file"
                                id="file-upload"
                                onChange={handleFileChange}
                                accept={acceptTypes}
                                multiple={multiple}
                                hidden
                            />
                            <label htmlFor="file-upload" className="file-upload-button">
                                {fileUploadButtonText}
                            </label>

                            {/* 여기에 파일 목록 표시 부분 추가 */}
                            {files.length > 0 && (
                                <div className="selected-files-container">
                                    <div className="selected-files-header">
                                        <h4>선택된 파일 목록 (총 {files.length}개)</h4>
                                        <button
                                            type="button"
                                            onClick={clearAllFiles}
                                            className="clear-all-button"
                                        >
                                            전체 취소
                                        </button>
                                    </div>
                                    <div className="selected-files-list">
                                        {currentFiles.map((file, index) => (
                                            <div key={indexOfFirstFile + index} className="file-item">
                                                <span className="file-number">{indexOfFirstFile + index + 1}.</span>
                                                <span className="file-name">{file.name}</span>
                                                <button
                                                    type="button"
                                                    onClick={() => handleRemoveFile(indexOfFirstFile + index)}
                                                    className="remove-file-button"
                                                >
                                                    ✕
                                                </button>
                                            </div>
                                        ))}
                                    </div>
                                    {totalPages > 1 && (
                                        <div className="pagination">
                                            <button
                                                type="button"  // 이 부분 추가
                                                onClick={() => handlePageChange(currentPage - 1)}
                                                disabled={currentPage === 1}
                                                className="pagination-button"
                                            >
                                                이전
                                            </button>
                                            <span className="page-info">
                                                {currentPage} / {totalPages}
                                            </span>
                                            <button
                                                type="button"  // 이 부분 추가
                                                onClick={() => handlePageChange(currentPage + 1)}
                                                disabled={currentPage === totalPages}
                                                className="pagination-button"
                                            >
                                                다음
                                            </button>
                                        </div>
                                    )}
                                </div>
                            )}
                        </div>
                    )}

                    {error && <div className="error-message">{error}</div>}

                    <div className="import-container">
                        <button
                            type="submit"
                            className="import-button"
                            disabled={isLoading || (isFileUpload && files.length === 0)}
                        >
                            {isLoading ? '처리중...' : submitButtonText}
                        </button>
                        {statusMessage && (
                            <div className={`status-message ${isLoading ? 'loading' : ''} ${statusMessage.length > 30 ? 'multiline' : ''}`}>
                                {statusMessage}
                            </div>
                        )}
                    </div>
                </form>

                {children}
            </div>
        </div>
    );
}

export default PageLayout;